import { render, staticRenderFns } from "./PurchaseNgList.vue?vue&type=template&id=1f68d002&scoped=true&"
import script from "./PurchaseNgList.vue?vue&type=script&lang=js&"
export * from "./PurchaseNgList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f68d002",
  null
  
)

export default component.exports